import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';

const CaptionEmphasis = (props) => (
  <span {...props} className={cn(styles.captionEmphasis, props.className)} />
);

CaptionEmphasis.propTypes = {
  className: PropTypes.string,
};

export default CaptionEmphasis;
